export async function showProductTopBar() {
    const productTopBar = (
        await import(
            /* webpackFetchPriority: "high" */
            "./product-topbar.vue"
        )
    ).default;
    const insertBanner = (
        await import(
            /* webpackFetchPriority: "high" */
            "./insert"
        )
    ).insertBanner;
    insertBanner({
        component: productTopBar,
        backgroundColor: "transparent",
        padding: function () {
            return "0px 0px";
        },
        borderBottom: "1px #E6E6E6 solid",
    });
}
